import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();

    return items.filter(item => this.itemContainsText(item, searchText));
  }

  private itemContainsText(item: any, searchText: string): boolean {
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item).toLowerCase().includes(searchText);
    }

    if (Array.isArray(item)) {
      return item.some(nestedItem => this.itemContainsText(nestedItem, searchText));
    }

    if (typeof item === 'object' && item !== null) {
      return Object.values(item).some(value => this.itemContainsText(value, searchText));
    }

    return false;
  }
}